import { useLayoutEffect } from 'react'
import {
  BACKGROUND_COLOR_MAP,
  BodyBackgroundColor,
  Cohort,
} from 'root-constants'
import { useSelector } from 'react-redux'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'
import { useLocation } from 'react-router'
import { getPageIdFromPathName } from 'helpers/getPageIdFromPathName'
import { PageId } from 'page-constants'

export const useBackgroundColor = () => {
  const { pathname } = useLocation()
  const cohort = useSelector(selectCurrentVariantCohort)

  useLayoutEffect(() => {
    const backgroundColor =
      getPageIdFromPathName(pathname) === PageId.RESULT
        ? BodyBackgroundColor.DARK_GRADIENT
        : BACKGROUND_COLOR_MAP[cohort || Cohort.VARIANT_ONE]

    document.documentElement.style.setProperty(
      '--body-background-color',
      backgroundColor,
    )
  }, [cohort, pathname])
}
